import { render, staticRenderFns } from "./FoodRecipe.vue?vue&type=template&id=e40ec3d2&scoped=true"
import script from "./FoodRecipe.vue?vue&type=script&lang=js"
export * from "./FoodRecipe.vue?vue&type=script&lang=js"
import style0 from "./FoodRecipe.vue?vue&type=style&index=0&id=e40ec3d2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40ec3d2",
  null
  
)

export default component.exports